import { useEffect } from 'react'
import { useAtomValue, useSetAtom } from 'jotai'
import { workspaceChallengeAtom, workspaceSettingsOpenAtom, workspaceTaskAtom } from '@/store/workspaceAtoms'
import { trackWorkspaceSettings } from '@/modules/workspaceSettingsAnalytics'

/**
 * Registers the global Cmd/Ctrl+, keyboard shortcut that toggles the
 * Workspace Settings dialog open state. Mount once from a component that
 * lives for the full workspace lifetime (e.g. Workspace).
 */
export const useWorkspaceSettingsShortcut = () => {
  const setOpen = useSetAtom(workspaceSettingsOpenAtom)
  const challenge = useAtomValue(workspaceChallengeAtom)
  const task = useAtomValue(workspaceTaskAtom)

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      const isModifier = e.metaKey || e.ctrlKey
      if (isModifier && e.key === ',') {
        // Prevent default so the browser's "Preferences" menu doesn't open.
        e.preventDefault()
        setOpen((prev) => {
          const next = !prev
          // Only trigger event for opening — close is tracked by the dialog itself with dwellMs.
          if (next) {
            trackWorkspaceSettings('workspace_settings:open', {
              source: 'shortcut',
              challengeId: challenge?.id,
              taskId: task?.id,
            })
          }
          return next
        })
      }
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [setOpen, challenge?.id, task?.id])
}
